import {detect} from "detect-browser";
import {isMobile} from "../../../utils/MobileUtils";

const makeBoolean = (browserObject) => {
    const result = {};
    for (const [key, fn] of Object.entries(browserObject)) {
        result[key] = (force) =>
            fn({children: true, fallback: false, force: force ?? false});
    }
    return result;
};

export const Browser = (() => {
    // do not show a component on default
    const defaultFallback = null;
    // browser names
    const safari = ["safari", "ios"];
    const firefox = ["firefox"];
    const chromium = ["chrome", "edge-chromium", "chromium-webview"];
    const opera = ["opera"];
    // supported browser names merged together
    const supportedBrowserList = [...safari, ...firefox, ...chromium, ...opera];
    // memoized value of browser name
    let browserName = null;
    let operatingSystem = null;

    let mobile = null;

    const getBrowserName = (force) => {
        // browserName should not change in a single session
        // there is no need to call detect every render
        if (force || browserName === null) {
            browserName = detect()?.name;
        }
        return browserName;
    };

    const getOperatingSystem = (force) => {
        if (force || operatingSystem === null) {
            operatingSystem = detect()?.os;
        }
        return operatingSystem;
    };

    const getIsMobile = (force) => {
        if (force || mobile === null) {
            mobile = isMobile();
        }
        return mobile;
    };

    const results = {
        Chrome: ({children, force, fallback = defaultFallback} = {}) => {
            return chromium.includes(getBrowserName(force))
                ? children
                : fallback;
        },
        Opera: ({children, force, fallback = defaultFallback} = {}) => {
            return opera.includes(getBrowserName(force)) ? children : fallback;
        },
        Firefox: ({children, force, fallback = defaultFallback} = {}) => {
            return firefox.includes(getBrowserName(force))
                ? children
                : fallback;
        },
        Supported: ({children, force, fallback = defaultFallback} = {}) => {
            return supportedBrowserList.includes(getBrowserName(force))
                ? children
                : fallback;
        },
        Safari: ({children, force, fallback = defaultFallback} = {}) => {
            return safari.includes(getBrowserName(force)) ? children : fallback;
        },
        NotSupported: ({children, force, fallback = defaultFallback} = {}) => {
            return !supportedBrowserList.includes(getBrowserName(force))
                ? children
                : fallback;
        },
        Mobile: ({children, force, fallback = defaultFallback} = {}) => {
            return getIsMobile(force) ? children : fallback;
        },
        Desktop: ({children, force, fallback = defaultFallback} = {}) => {
            return !getIsMobile(force) ? children : fallback;
        },
    };
    return {
        ...results,
        is: makeBoolean(results),
        get: {
            browserName: (force) => getBrowserName(force),
            operatingSystem: (force) => getOperatingSystem(force),
        },
    };
})();
